import { Component, OnInit } from '@angular/core';
import { LocationContextService } from '../../location-context/location-context.service';
import { LogService } from '../../logging/log.service';
import { NavigationService } from '../../navigation/navigation.service';
import { MaintenanceService } from '../../maintenance/maintenance.service';

@Component({
    selector: 'app-location-context-panel',
    templateUrl: './location-context-panel.component.html',
    styleUrls: ['./location-context-panel.component.scss']
})
export class LocationContextPanelComponent implements OnInit {
    LOG_SOURCE = 'LocationContextPanelComponent';
    onMaintenancePage: boolean;
    selectedCenterline: string;
    selectedDevice: string;
    isLocationContextValid: boolean;

    constructor(
        private readonly locationContextService: LocationContextService,
        private readonly navigationService: NavigationService,
        private readonly maintenanceService: MaintenanceService,
        private readonly logService: LogService
    ) {}

    ngOnInit() {
        this.onMaintenancePage = this.navigationService.onMaintenancePage();
        this.selectedCenterline = this.locationContextService.getSelectedCenterline();
        this.selectedDevice = this.maintenanceService.getDeviceIdFromSession();
        this.isLocationContextValid = this.locationContextService.isLocationContextValid();
        this.logService.info(this.LOG_SOURCE, 'Loaded location context panel', {});
    }

    redirectHome(): Promise<void> {
        this.logService.info(this.LOG_SOURCE, 'Redirecting user home', {});
        return this.navigationService.redirectToTerminalSelection().then(result => {
            if (result) {
                this.locationContextService.resetLocationContextDataAndSelection();
            }
        });
    }

    redirectUp(): Promise<void> {
        this.logService.info(this.LOG_SOURCE, 'Redirecting user up', {});
        return this.navigationService.redirectBack().then(result => {
            if (result) {
                this.logService.info(this.LOG_SOURCE, 'Resetting location context data', {});
                this.locationContextService.resetLocationContextData();
            }
        });
    }

    isUpButtonAvailable() {
        if (!this.locationContextService.isSingleCenterline()) {
            return true;
        }
        if (!this.locationContextService.isSingleCenterlineGroup()) {
            return true;
        }
        return false;
    }
}
